import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';

interface CheckboxProps {
  size?: 'medium' | 'small' | string;
  color?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
    | string;
  label?: string | Element;
  meta: {
    touched: boolean;
    invalid: boolean;
    error: boolean;
  };
  input: {
    value: boolean;
    onChange: any;
    checked: boolean;
    className?: string;
  };
  fullWidth: boolean;
  classes?: Record<string, any>;
  disabled?: boolean;
  onClick?: Function;
}

const CheckboxField = ({
  label = '',
  input,
  fullWidth,
  classes,
  disabled = false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick = () => {}
}: CheckboxProps) => {
  return (
    <FormControl fullWidth={fullWidth}>
      <FormControlLabel
        classes={classes ? classes : {}}
        control={
          <Checkbox
            onClick={() => {
              onClick();
            }}
            disabled={disabled}
            style={{ padding: 0 }}
            color="default"
            {...input}
            className={input.className ? input.className : 'checkbox'}
            checked={input.value}
          />
        }
        label={label as any}
      />
    </FormControl>
  );
};

export default CheckboxField;
